export const apiFetch = async (
  url,
  options = {},
  responseType = 'json',
  language = 'en',
  goToError,
  goToUnauthorized
) => {

  try {
    const utcOffsetMinutes = new Date().getTimezoneOffset();
    const utcOffsetHours = -(utcOffsetMinutes / 60);

    const clientInfo = `${navigator.userAgent} (${navigator.language})`;

    const headers = {
      ...options.headers,
      'Accept-Language': language,
      'UTC-Offset': utcOffsetHours.toString(),
      'X-Client-Info': clientInfo,
    };

    const response = await fetch(url, { ...options, headers });

    let data;
    if (responseType === 'text' || responseType === 'txt') {
      data = await response.text();
    } else {
      const text = await response.text();
      data = text ? JSON.parse(text) : null;
    }

    if (!response.ok) {
      if (response.status === 500) {
        console.error("Server Error (500): Redirecting to error page.");
        goToError?.();
        return;
      }

      if (response.status === 401 || response.status === 403) {
        console.warn(`Redirecting due to auth error (${response.status})`);
        if (goToUnauthorized) goToUnauthorized();
        return null; 
      }

      if (response.status >= 400 && response.status < 500) {
        return {
          status: response.status,
          data,
        };
      }

      // Other errors
      const error = new Error('API request failed');
      error.status = response.status;
      error.data = data;
      throw error;
    }

    return {
      status: response.status,
      data,
    };
  } catch (error) {
    console.error('API call failed:', url, error);

    // Optional: prevent redirect loop if it's a network-level 401
    if (error.status === 401 || error.status === 403) {
      goToUnauthorized?.();
      return;
    }

    goToError?.();
    return;
  }
};


export default apiFetch;
